"use strict";
/**
 * Time-Off Request Enums
 *
 * Single source of truth for time-off request statuses and types.
 * Used by both backend and frontend.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_OFF_STATUS_LABELS = exports.TIME_OFF_TYPE_LABELS = exports.TimeOffType = exports.TimeOffStatus = void 0;
var TimeOffStatus;
(function (TimeOffStatus) {
    TimeOffStatus["Pending"] = "Pending";
    TimeOffStatus["Approved"] = "Approved";
    TimeOffStatus["Rejected"] = "Rejected";
    TimeOffStatus["Canceled"] = "Canceled";
})(TimeOffStatus || (exports.TimeOffStatus = TimeOffStatus = {}));
var TimeOffType;
(function (TimeOffType) {
    TimeOffType["Vacation"] = "Vacation";
    TimeOffType["PersonalLeave"] = "Asuntos propios";
    TimeOffType["SickLeaveIMSS"] = "Incapacidad por IMSS";
    TimeOffType["ShiftToBeCompensated"] = "Jornada a reponer";
    TimeOffType["JustifiedAbsenceByCompany"] = "Inasistencia justificada por la empresa";
    TimeOffType["AuthorizedUnjustifiedAbsence"] = "Falta injustificada autorizada";
    TimeOffType["EarlyLeavePermission"] = "Permiso de salida anticipada";
    TimeOffType["LatePermission"] = "Permiso de llegar tarde";
    TimeOffType["CompensationShift"] = "Reposici\u00F3n de jornada";
    /**
     * Employer-paid authorized absence at full ordinary salary (paternity,
     * marriage, bereavement, etc.). The specific motive goes in the request note.
     * Pays full salary, NO discount, does NOT consume vacation balance, grants
     * NO prima vacacional, and pays NO commission/average-income compensation.
     */
    TimeOffType["PaidLeave"] = "Permiso con goce de sueldo";
})(TimeOffType || (exports.TimeOffType = TimeOffType = {}));
/** Spanish display labels for TimeOffType */
exports.TIME_OFF_TYPE_LABELS = {
    [TimeOffType.Vacation]: 'Vacaciones',
    [TimeOffType.PersonalLeave]: 'Asuntos propios',
    [TimeOffType.SickLeaveIMSS]: 'Incapacidad por IMSS',
    [TimeOffType.ShiftToBeCompensated]: 'Jornada a reponer',
    [TimeOffType.JustifiedAbsenceByCompany]: 'Inasistencia justificada por la empresa',
    [TimeOffType.AuthorizedUnjustifiedAbsence]: 'Falta injustificada autorizada',
    [TimeOffType.EarlyLeavePermission]: 'Permiso de salida anticipada',
    [TimeOffType.LatePermission]: 'Permiso de llegar tarde',
    [TimeOffType.CompensationShift]: 'Reposición de jornada',
    [TimeOffType.PaidLeave]: 'Permiso con goce de sueldo',
};
/** Spanish display labels for TimeOffStatus */
exports.TIME_OFF_STATUS_LABELS = {
    [TimeOffStatus.Pending]: 'Pendiente',
    [TimeOffStatus.Approved]: 'Aprobada',
    [TimeOffStatus.Rejected]: 'Rechazada',
    [TimeOffStatus.Canceled]: 'Cancelada',
};
